import { QSetReviewTaskProvider } from '@exam-management/qset-review-task-detail';
import { useParams } from '@exam-management/router';
import {
  QSetReviewModalProvider,
  TaskManagementPermissionRoute,
} from '@exam-management/task-management';
import { Outlet } from 'react-router-dom';

export default function QSetReviewTaskLayout() {
  const { taskId } = useParams('/my-task/qset-review/:taskId');
  return (
    <TaskManagementPermissionRoute taskId={taskId}>
      <QSetReviewTaskProvider taskId={taskId}>
        <QSetReviewModalProvider>
          <Outlet />
        </QSetReviewModalProvider>
      </QSetReviewTaskProvider>
    </TaskManagementPermissionRoute>
  );
}
